import React from "react"

export default function Module({
  title,
  subtitle,
  label,
  color,
  classes,
  content,
}) {
  return (
    <div
      className={
        "module" +
        (color ? " module--theme-color-" + color : "") +
        (classes ? " " + classes : "")
      }
    >
      <header>
        <h3 className="title--quaternary title--uppercase">{title}</h3>
        {subtitle ? (
          <p className="title--meta title--light">{subtitle}</p>
        ) : null}
        {label ? (
          <p
            className="title--micro title--uppercase title--light"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        ) : null}
      </header>
      <div className="module__content">{content}</div>
    </div>
  )
}
